import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    refetch: false,
    availability: {},
  },
  reducers: {
    setAvailability: (state, action) => {
      state.availability = action.payload;
    },
    refetch: (state, action) => {
      state.refetch = action.payload;
    },
  },
});

export const { refetch, setAvailability } = chatSlice.actions;

export const deleteChats =
  (id, setIsLoading, setDeleteModal) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${process.env.REACT_APP_API_BASE_URL}/chat/delete/${id}/v1`;
      const { data } = await axios.delete(url, {
        headers: { Authorization: localStorage.getItem("sgtoken") },
      });
      console.log(data);
      dispatch(refetch(true));
      toast.success("Deleted Successfully", {
        position: "top-center",
        autoClose: 5000,
      });
      setIsLoading(false);
      setDeleteModal(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setDeleteModal(false);
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 5000,
      });
    }
  };

export const manageTimeAvailability =
  (id, availability) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${process.env.REACT_APP_API_BASE_URL}/chat/availabilityTime/update/${id}/v1`;
      const { data } = await axios.put(url, availability, {
        headers: { Authorization: localStorage.getItem("sgtoken") },
      });

      dispatch(refetch(true));
      toast.success("Time Availability Updated Successfully", {
        position: "top-center",
        autoClose: 5000,
      });
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 5000,
      });
    }
  };

export const getAvailabilityTime = () => async (dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/chat/availabilityTime/list/v1`;
    const { data } = await axios.get(url, {
      headers: { Authorization: localStorage.getItem("sgtoken") },
    });
    dispatch(setAvailability(data.data));
  } catch (error) {
    console.log(error);
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 5000,
    });
  }
};

export default chatSlice.reducer;
